module.exports = __webpack_public_path__ + "images/category_lp/home_appliance/new/store_images/1_9424fe592b4b979b0ac8fe6831adc12c.png";